import { EnumValues } from 'enum-values'
import { PaymentMethodBrand, StripeCardBrand } from '../types'

export class PaymentMethodUtils {
  public static isTippingSupported(brand: PaymentMethodBrand): boolean {
    return [...EnumValues.getValues(StripeCardBrand), PaymentMethodBrand.Sepa].includes(brand)
  }
}
